import React from 'react';
import useFormCallback from '../../Hooks/useFormCallback';
import LoadingScreen from './LoadingSpinner';

function Form({onSubmit, children, onValidityCheckAdd, isNew = true, loading, onValidityCheckRemove, forceCallback, isValid, symbol, ...props}, potentialRef) {
    const localRef = React.useRef(null);

    React.useEffect(() => {
        if (typeof onValidityCheckAdd === "function" && typeof onValidityCheckRemove === "function") {
            const checkValidity = () => {
                return localRef.current.reportValidity();
            };
            onValidityCheckAdd(checkValidity)
            return () => onValidityCheckRemove(checkValidity);
            
        }
    }, [onValidityCheckAdd, onValidityCheckRemove]);
    
    useFormCallback({  formRef: localRef, onSubmit, isNew, forceCallback, isValid, symbol});
    return (
        <form
            ref={(_ref) => {
                localRef.current = _ref;

                if (potentialRef !== undefined && potentialRef !== null) {
                    potentialRef.current = _ref;
                }
            }}
            onSubmit={(event) => {
                event.preventDefault();
                if (localRef.current.reportValidity() && typeof onSubmit === "function") {
                    onSubmit();
                }
            }} 
            {...props}
        >
            {children}
            {loading && <LoadingScreen style={{position: "absolute"}} />}
        </form>
    );
}

export default React.forwardRef(Form);